export const dateFormatter = (stringValue, options) =>
  new Intl.DateTimeFormat('en-US', options)
    .format(new Date(stringValue))
    .replace(/, /g, ' ');
